import { render, staticRenderFns } from "./SingleSearchResult.vue?vue&type=template&id=9fc24b0a&scoped=true"
import script from "./SingleSearchResult.vue?vue&type=script&lang=js"
export * from "./SingleSearchResult.vue?vue&type=script&lang=js"
import style0 from "./SingleSearchResult.vue?vue&type=style&index=0&id=9fc24b0a&prod&lang=less"
import style1 from "./SingleSearchResult.vue?vue&type=style&index=1&id=9fc24b0a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fc24b0a",
  null
  
)

export default component.exports